import { useAuth0 } from '@auth0/auth0-react'
import { useStores } from '../../hooks'
import { classNames } from '../../utils'
import { MdArrowBackIos } from 'react-icons/md'
import { NewOnBoardingProps } from './types'
import { OnBoardingSteps } from '../on-boarding-steps'

export const NewOnboarding = ({
	children,
	title,
	description,
	backToLogin,
	disableTopAction,
	contentClassName,
	contentRootClassName,
	containerWidth,
	hasProgressBar = false,
	progressStepsBar = [0, 0, 0],
	hasGap,
	state,
	handleBack,
	centerTitle
}: NewOnBoardingProps) => {
	const { adminStore } = useStores()
	const { logout } = useAuth0()

	return (
		<div
			className={`relative ${
				containerWidth ? containerWidth : 'max-w-[610px]'
			} flex md:gap-0  ${
				hasGap ? hasGap : 'gap-12'
			} md:items-center flex-col md:justify-center md:min-h-[80vh] mx-auto sm:px-6 lg:px-8 text-t-dark`}
		>
			<div className="md:py-6 w-full md:order-1 order-2">
				<div className="bg-t-smoke rounded-3xl md:shadow-lg overflow-hidden">
					<div
						className={`lg:w-full lg:flex lg:flex-col space-y-4 relative sm:block ${
							contentClassName || 'md:p-12 sm:px-12 sm:py-12 p-2'
						}`}
					>
						{state?.step === 'SETUP_COMPLETE' && (
							<div
								className="mt-4 mr-8 absolute right-0 top-0 text-sm text-primary-500 cursor-pointer"
								onClick={handleBack}
							>
								Go to dashboard
							</div>
						)}

						<div
							className={classNames(
								contentRootClassName || 'mt-0  w-full relative'
							)}
						>
							{centerTitle && (
								<div>
									<div className="text-t-base-blue mb-6 text-center md:text-[30px] text-2xl md:leading-9 leading-7 font-medium">
										{centerTitle}
									</div>
								</div>
							)}

							{title && (
								<div className="text-t-base-blue mb-8 md:text-left text-center md:text-[30px] text-2xl md:leading-9 leading-7 md:font-normal font-medium">
									{title}
									<div className="text-t-desc-gray text-[16px] md:text-left text-center mt-1 font-[300] leading-5 w-full">
										{description}
									</div>
								</div>
							)}
							{children}
							{!disableTopAction && (
								<div
									className="mt-4 flex items-center justify-center cursor-pointer"
									onClick={() => {
										localStorage.setItem('isLogin', 'true')
										adminStore.clearImpersonation()
										logout()
									}}
								>
									{backToLogin && (
										<>
											<span className="text-t-blue-active text-md leading-5 font-normal flex items-center">
												<MdArrowBackIos />
												Back to login screen
											</span>
										</>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			{hasProgressBar && <OnBoardingSteps steps={progressStepsBar} />}
		</div>
	)
}
